var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 21.3327H18.6666M11.7333 29.3327H20.2666C22.5068 29.3327 23.6269 29.3327 24.4825 28.8967C25.2352 28.5132 25.8471 27.9013 26.2306 27.1486C26.6666 26.293 26.6666 25.1729 26.6666 22.9327V9.06602C26.6666 6.82581 26.6666 5.7057 26.2306 4.85005C25.8471 4.09741 25.2352 3.48548 24.4825 3.10199C23.6269 2.66602 22.5068 2.66602 20.2666 2.66602H11.7333C9.49304 2.66602 8.37294 2.66602 7.51729 3.10199C6.76464 3.48548 6.15272 4.09741 5.76923 4.85005C5.33325 5.7057 5.33325 6.82581 5.33325 9.06602V22.9327C5.33325 25.1729 5.33325 26.293 5.76923 27.1486C6.15272 27.9013 6.76464 28.5132 7.51729 28.8967C8.37294 29.3327 9.49304 29.3327 11.7333 29.3327ZM19.9999 11.9993C19.9999 14.2085 18.2091 15.9993 15.9999 15.9993C13.7908 15.9993 11.9999 14.2085 11.9999 11.9993C11.9999 9.79021 13.7908 7.99935 15.9999 7.99935C18.2091 7.99935 19.9999 9.79021 19.9999 11.9993Z",
    stroke: "#395BA9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdVerification);
export default __webpack_public_path__ + "static/media/IdVerification.a38bebd95ee3fb449c2a066aa5f670ad.svg";
export { ForwardRef as ReactComponent };